import { DatePicker, Input, Select, Space } from 'antd';
import inputSearch from '../../../../../assets/img/input-search.png';
import getFormatMessage from '../../../../../locales/get-format-message';
import styles from './index.module.scss';
import { ORDER_STATUS_OPTIONS } from '../../../../studio/lib/service-order';
import { useState } from 'react';
import { OrderStatus } from '../../../../../model/api-modules';
import { IFilterValues } from '../../../../../model/billing-center';
import classNames from 'classnames';
import { Moment } from 'moment';

const { RangePicker } = DatePicker;

interface IProps {
  onChange: (value: IFilterValues) => void;
}

export const OrderFilter = (props: IProps) => {
  const [dateRange, setDateRange] = useState<
    [Moment | null, Moment | null] | null
  >([null, null]);
  const [status, setStatus] = useState<OrderStatus>();
  const [searchText, setSearchText] = useState<string>('');

  const onChange = (changeFields: IFilterValues) => {
    props.onChange({
      dateRange,
      status,
      searchText,
      ...changeFields,
    });
  };

  return (
    <div className={styles.filterBox}>
      <Space direction="horizontal" size={12}>
        <RangePicker
          dropdownClassName="fee-data-dropdown day-data-dropdown"
          className={styles.orderDicker}
          onChange={(range) => {
            setDateRange(range);
            onChange({ dateRange: range });
          }}
        />

        <Select
          allowClear
          options={ORDER_STATUS_OPTIONS}
          style={{
            minWidth: 160,
            maxWidth: 300,
            // @ts-ignore
            '--input-label': `"${getFormatMessage('order_status')}"`,
          }}
          onChange={(val) => {
            setStatus(val);
            onChange({ status: val });
          }}
        />

        <Input
          className={styles.searchInput}
          prefix={
            <img
              src={inputSearch}
              className={classNames('icon', styles.inputSearch)}
            />
          }
          allowClear
          spellCheck="false"
          placeholder={`${getFormatMessage('order_id')}/${getFormatMessage(
            'order_creator'
          )}`}
          onChange={(ev) => {
            setSearchText(ev.target.value);
            onChange({ searchText: ev.target.value });
          }}
        />
      </Space>
    </div>
  );
};
